export const getImage = (src: string, config: any) => {
  const { modifiers = {}, preset, imageFormat } = config;
  const { width, height, quality = 75 } = modifiers;

  // Bypass if no preset or host doesn't match
  try {
    const host = new URL(src).host;
    if (!preset || !/media.*kik/.test(host)) {
      return { url: src };
    }
  }
  catch {
    // If src isn't a valid URL, just return it unchanged
    return { url: src };
  }

  // Extract dimensions and quality from operations or use modifiers as fallback
  const dimensions = `${width}-${height}`;
  const qualityModifier = quality;

  // Extract existing size and format from URL
  const [, sizeInSrc] = src.match(/(\d*-\d*)\/\w*.\w*/) || [];
  const [imageFormatInSrc] = src.match(/.\w*$/) || [];

  let url = src;

  // Apply image format conversion if configured
  if (
    imageFormatInSrc
    && imageFormat?.from?.map((f: string) => `.${f}`).includes(imageFormatInSrc)
  ) {
    url = url.replace(imageFormatInSrc, `.${imageFormat.to}`);
  }

  // Apply size and quality modifications to URL
  if (sizeInSrc) {
    url = url.replace(sizeInSrc, `${dimensions}/${qualityModifier}`);
  }

  return { url };
};
